var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGswmMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_564_4436)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05991 5.86021C10.3403 2.5798 15.6589 2.5798 18.9393 5.86021C22.2197 9.14061 22.2197 14.4592 18.9393 17.7395L12.9996 23.6793L7.05991 17.7395C3.77951 14.4592 3.77951 9.14061 7.05991 5.86021Z",
    style: {
      fill: "rgb(116, 98, 225)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5857 6.21375L18.5857 6.21376C21.6709 9.2989 21.6709 14.3009 18.5857 17.386L18.5857 17.386L12.9996 22.9722L7.41347 17.386L7.41346 17.386C4.32833 14.3009 4.32832 9.2989 7.41347 6.21376C10.4986 3.12861 15.5006 3.12862 18.5857 6.21375Z",
    stroke: "#0051A9"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(255, 255, 255)",
      fontFamily: "Arial, sans-serif",
      fontSize: 3,
      fontWeight: 700,
      textTransform: "capitalize",
      whiteSpace: "pre"
    },
    x: 7.908,
    y: 13.53
  }, "GSWM")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_564_4436)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_564_4436",
    x: 0.599609,
    y: 0.399902,
    width: 24.7998,
    height: 28.2793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_564_4436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_564_4436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_564_4436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGswmMarker);
export default __webpack_public_path__ + "static/media/gswm-marker.ca64c110e403e6ed0514b380115e4342.svg";
export { ForwardRef as ReactComponent };